"use strict";

exports.__esModule = true;
exports.AssignUser = AssignUser;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _User = require("../../User");
var _Utils = require("../../../Utils");
var _excluded = ["onAssign", "assigneeID"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function AssignUser(_ref) {
  var onAssign = _ref.onAssign,
    assigneeID = _ref.assigneeID,
    dialogProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_User.UserListContext),
    users = _React$useContext2.users;
  var userList = Object.values(users).filter(function (user) {
    return user.isEnabled;
  }).map(function (user) {
    return Object.assign({}, user, {
      // $FlowIgnore
      displayName: (0, _Utils.formatUserName)(user)
    });
  });
  var user = assigneeID ? users[assigneeID] : undefined;
  var _useState = (0, _react.useState)(user ? [user] : []),
    selectedUser = _useState[0],
    setSelectedUser = _useState[1];
  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, _extends({}, dialogProps, {
    title: translate("TicketDetails.AssignUser.AssignToUser", "Assign to User"),
    usePortal: false,
    style: {
      maxWidth: "350px"
    }
  }), /*#__PURE__*/_react["default"].createElement("main", {
    className: _core.Classes.DIALOG_BODY
  }, /*#__PURE__*/_react["default"].createElement(_core.Label, {
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, "User", /*#__PURE__*/_react["default"].createElement(_User.UserSelector, {
    selected: selectedUser,
    items: userList,
    onSelect: setSelectedUser,
    style: {
      maxWidth: "310px",
      justifyContent: "space-between"
    }
  }))), /*#__PURE__*/_react["default"].createElement("footer", {
    className: _core.Classes.DIALOG_FOOTER
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: _core.Classes.DIALOG_FOOTER_ACTIONS
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    intent: _core.Intent.PRIMARY,
    disabled: !(selectedUser[0] && onAssign) || selectedUser[0].id === assigneeID,
    "data-testid": "TicketDetails.AssignUser.AssignButton",
    text: translate("TicketDetails.AssignUser.AssignButton", "Assign"),
    onClick: function onClick() {
      if (onAssign) {
        onAssign(selectedUser[0].id);
      }
      dialogProps.onClose();
    }
  }))));
}